import type { Question } from "../data/types";
import type { BankStats } from "../data/questions";

/** Gốc API. Mặc định "/api" — cùng domain với web (nginx/vite proxy chuyển tới backend). */
export const API_URL = ((import.meta.env.VITE_API_URL as string | undefined) ?? "/api").replace(/\/$/, "");
export const TOKEN_KEY = "claude-cert-prep:token:v1";

export interface ApiUser { id: string; email: string; name: string | null; avatar_url: string | null; created_at: string }

export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
  }
}

export function getToken(): string | null {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}
export function setToken(t: string | null): void {
  try { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); } catch { /* bỏ qua */ }
}

async function call<T>(path: string, init: RequestInit = {}, auth = true): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body) headers.set("Content-Type", "application/json");
  const token = auth ? getToken() : null;
  if (token) headers.set("Authorization", `Bearer ${token}`);
  const res = await fetch(`${API_URL}${path}`, { ...init, headers });
  const data = (await res.json().catch(() => ({}))) as T & { error?: string };
  if (!res.ok) throw new ApiError(res.status, data.error ?? `http-${res.status}`);
  return data;
}

export const api = {
  loginGoogle: (credential: string) => call<{ token: string; user: ApiUser }>("/auth/google", { method: "POST", body: JSON.stringify({ credential }) }, false),
  loginDev: (email: string) => call<{ token: string; user: ApiUser }>("/auth/dev", { method: "POST", body: JSON.stringify({ email }) }, false),
  me: () => call<{ user: ApiUser }>("/me"),
  deleteMe: () => call<{ ok: true }>("/me", { method: "DELETE" }),
  questions: () => call<{ questions: Question[] }>("/questions"),
  publicQuestions: () => call<{ questions: Question[]; stats: BankStats }>("/questions/public", {}, false),
  getProgress: () => call<{ progress: unknown | null }>("/progress"),
  putProgress: (progress: unknown) => call<{ ok: true }>("/progress", { method: "PUT", body: JSON.stringify({ progress }) }),
  feedback: (body: unknown) => call<{ ok: true }>("/feedback", { method: "POST", body: JSON.stringify(body) }),
};
